<script setup lang="ts">
import { parseVariableTokens, segmentsToHtml } from '@/utils/String'

const props = defineProps<{
  text: string | undefined | null
  variableNames: Set<string>
}>()

const segments = computed(() => parseVariableTokens(props.text, props.variableNames))
const tooltipContent = computed(() => segmentsToHtml(segments.value))
</script>

<template>
  <OOverflowTooltip :content="tooltipContent">
    <span v-for="(seg, i) in segments" :key="i">
      <s v-if="seg.isVar && seg.deleted">{{ seg.text }}</s>
      <template v-else>{{ seg.text }}</template>
    </span>
  </OOverflowTooltip>
</template>
